function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

import { Event } from 'meteora';

var ScrollLocker = /*#__PURE__*/function () {
  function ScrollLocker(el) {
    _classCallCheck(this, ScrollLocker);

    this.body = document.querySelector('html');
    this.event = new Event('resize');
    this.el = el;
    this.y = 0;
  }

  _createClass(ScrollLocker, [{
    key: "lock",
    value: function lock() {
      this.y = window.pageYOffset;
      this.el.style.height = window.innerHeight + 'px';
      this.body.style.height = window.innerHeight + 'px';
      this.body.style.overflow = 'hidden';
      this.el.scrollTop = this.y;
      this.body.scrollTop = 0;
      window.dispatchEvent(new Event('resize'));
    }
  }, {
    key: "unlock",
    value: function unlock() {
      this.el.style.height = 'auto';
      this.body.style.height = 'auto';
      this.body.style.overflow = 'visible';
      this.body.scrollTop = this.y;
      window.dispatchEvent(this.event);
    }
  }]);

  return ScrollLocker;
}();

export { ScrollLocker as default };